import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { type ComplianceCaseTypeEnum as ComplianceCaseTypeUnion } from "~/graphql/supergraphTypes";

export const PI_GRID_COLUMNS = {
  BENEFICIARY: "Payment beneficiary",
  SCREENING: "Screening",
};

export const SCREENING_TOOLTIP =
  "This is the result if this account profile is used as the owner of the updated payment instruction";

export const ONBOARDING_CASE_TYPES: readonly ComplianceCaseTypeUnion[] = [
  ComplianceCaseTypeEnum.InvestorOnboarding,
  ComplianceCaseTypeEnum.Remediation,
];
